import React from 'react'
import { Link, StaticQuery, graphql } from 'gatsby'
import Navigation from './Navigation'
import SocialLinks from './SocialLinks'
import IconMenu from '../icons/menu.svg'
import IconSearch from '../icons/search.svg'
import IconClose from '../icons/close.svg'
import SearchPopup from './SearchPopup'

const Header = ({
	logo,
	searchIndex,
	shortName,
	shortDescription,
	socialLinks,
}) => {
	const [searchToggle, setSearchToggle] = React.useState(false)
	const [menuToggle, setMenuToggle] = React.useState(false)

	return (
		<>
			<header className={`site-header ${menuToggle && `mobile-menu-opened`}`}>
				<div className="logo-wrap">
					{logo ? (
						<Link className="image-logo" to={`/`}>
							<img src={logo.childImageSharp.fluid.src} alt={shortName} />
						</Link>
					) : (
						<Link className="text-logo" to={`/`}>
							{shortName}
						</Link>
					)}
					<div className="site-description">{shortDescription}</div>
				</div>
				<nav className="site-nav">
					<ul>
						<Navigation />
					</ul>
				</nav>
				<span
					className="menu-button"
					id="menu-open"
					onClick={() => setMenuToggle(true)}
				>
					<IconMenu />
				</span>
				<div className="header-bottom text-center">
					<div
						className="search-btn-wrap"
						onClick={() => setSearchToggle(true)}
					>
						<span className="search-btn search-open">
							<IconSearch />
							Search
						</span>
					</div>
					<SocialLinks socialLinks={socialLinks} />
				</div>
				<nav className="mobile-menu" id="mobile-menu">
					<ul>
						<Navigation />
					</ul>
					<div className="mobile-header-bottom text-center">
						<div
							className="search-btn-wrap"
							onClick={() => setSearchToggle(true)}
						>
							<span className="search-btn search-open">
								<IconSearch />
								Search
							</span>
						</div>
						<SocialLinks socialLinks={socialLinks} />
					</div>
				</nav>
				<div
					className="backdrop"
					id="backdrop"
					onClick={() => setMenuToggle(false)}
				>
					<span className="menu-close align-center">
						<IconClose />
					</span>
				</div>
			</header>
			<div className={`search-popup ${searchToggle && `visible`}`}>
				<div className="close-button" onClick={() => setSearchToggle(false)}>
					<IconClose />
				</div>
				<SearchPopup searchIndex={searchIndex} />
			</div>
		</>
	)
}

const logoQuery = graphql`
	query {
		logo: file(absolutePath: { regex: "/logo./" }) {
			childImageSharp {
				fluid(maxWidth: 240) {
					...GatsbyImageSharpFluid
				}
			}
		}
		allSite {
			nodes {
				siteMetadata {
					themeOptions {
						site {
							shortName
							shortDescription
							twitter
							facebook
							instagram
							dribbble
							behance
						}
					}
				}
			}
		}
		siteSearchIndex {
			index
		}
	}
`

export default () => (
	<StaticQuery
		query={logoQuery}
		render={data => (
			<Header
				logo={data.logo}
				searchIndex={data.siteSearchIndex.index}
				shortName={
					data.allSite.nodes[0].siteMetadata.themeOptions.site.shortName
				}
				shortDescription={
					data.allSite.nodes[0].siteMetadata.themeOptions.site.shortDescription
				}
				socialLinks={data.allSite.nodes[0].siteMetadata.themeOptions.site}
			/>
		)}
	/>
)
